import ReactDOM from "react-dom/client";
import "./sentry";

import { IncomeProvider } from "./hooks/useData";
import { useState } from "react";
import { SuperTokensWrapper } from "supertokens-auth-react";
import { RouterProvider } from "react-router-dom";
import "./services/supertokens";
import { Client } from "./types";
import router from "./router";

function App() {
  const [clientData, setClientData] = useState<Client | null>({} as any);
  return (
    <SuperTokensWrapper>
      <IncomeProvider data={clientData as any} setLocal={setClientData as any}>
        <RouterProvider router={router} />
      </IncomeProvider>
    </SuperTokensWrapper>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
